module.exports = __webpack_public_path__ + "img/Cas9variants_R.27eab204.svg";